// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"1127e70c","221":"7ecf7189","305":"b2eda15d","347":"56a99d3f","358":"9f965acf","427":"fbdadf6d","453":"18c796c0","683":"7fd7e072","906":"23b46a02"}[chunkId] + ".chunk.js";
};